import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/topic/point"

const topicPoint = {
  pointSortList(pageSize, limit, keyWord, subjectId, classId) {
    return axios.get(pre + `/pointSortList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
          classId: classId
        }
    });
  },

  pointSortAllList(subjectId, classId) {
    return axios.get(pre + `/pointSortAllList`, {
      params:
        {
          subjectId: subjectId,
          classId: classId,
        }
    });
  },
  pointSortInfo(id) {
    return axios.get(pre + `/pointSortInfo`, {params: {id: id}});
  },
  savePointSort(params) {
    return axios.post(pre + `/savePointSort`, qs.stringify(params));
  },
  pointSortDelete(id) {
    return axios.delete(pre + `/pointSortDelete`, {params: {id: id}});
  },




}
export default topicPoint;



// WEBPACK FOOTER //
// ./src/api/topic/topicPoint.js